import { useMemo } from 'react';
import { LinearCanonicalNetworkEditedRow } from '@blisspointmedia/bpm-types/dist/LinearAssignments';
import { EntityOverviewForm, OverviewSection } from '@Components/EntityOverviewForm';
import { OVERVIEW_SECTIONS } from './linear-networks-constants';

interface NetworkOverviewProps {
  network: LinearCanonicalNetworkEditedRow;
  saving: boolean;
  networkGroups: string[];
  onSave: (updated: LinearCanonicalNetworkEditedRow) => Promise<boolean>;
}

export const NetworkOverview = ({
  network,
  saving,
  networkGroups,
  onSave
}: NetworkOverviewProps) => {
  // 'Network Group' is the one field whose options depend on the current network list rather than
  // being fixed at module load — fill it in here rather than in the shared static config.
  const sections = useMemo<OverviewSection[]>(
    () =>
      OVERVIEW_SECTIONS.map(section => ({
        ...section,
        fields: section.fields.map(field =>
          field.field === 'Network Group'
            ? { ...field, options: networkGroups.map(group => ({ label: group, value: group })) }
            : field
        )
      })),
    [networkGroups]
  );

  return (
    <EntityOverviewForm<LinearCanonicalNetworkEditedRow>
      entity={network}
      sections={sections}
      saving={saving}
      onSave={onSave}
    />
  );
};
